var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#27A376",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4023 18.2461H23.6013V21.7942H16.4023V18.2461Z",
    fill: "#27A376"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9526 17.2812H28.4531V22.5135H28.9526C29.5298 22.5128 29.9976 22.0451 29.9981 21.4677V18.3267C29.9974 17.7495 29.5296 17.2818 28.9526 17.2812Z",
    fill: "#27A376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4952 15.0703H24.5117V24.9733H26.4952C27.0724 24.9726 27.5402 24.5049 27.5408 23.9277V16.1159C27.5402 15.5387 27.0724 15.071 26.4952 15.0703Z",
    fill: "#27A376"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.457 16.1159V23.9277C12.4576 24.5049 12.9254 24.9727 13.5026 24.9733H15.4861V15.0703H13.5026C12.9254 15.071 12.4576 15.5387 12.457 16.1159Z",
    fill: "#27A376"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3268V21.4677C10.0005 22.0451 10.4684 22.5128 11.0456 22.5135H11.545V17.2812H11.0456C10.4684 17.2818 10.0007 17.7496 10 18.3268Z",
    fill: "#27A376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.e08863e5ee177c231cbb7a4f81feddc8.svg";
export { ForwardRef as ReactComponent };